import React, {
  useCallback,
  useEffect
} from 'react'
import {
  Typography,
  Snackbar
} from '@mui/material'
import { Alert } from '@mui/lab'
import {
  ConsoleLike,
  Testable
} from '@eventops/chronotrack-ctlive-mui'

export type SnackbarSeverity = 'success' | 'info' | 'error' | 'warning'
export type SnackbarMessageLine = {
  message: string
  style?: React.CSSProperties
}
export type SnackbarMessageInfo = {
  open: boolean
  messageLines: SnackbarMessageLine[]
  severity: SnackbarSeverity
}

export type AppSnackbarProps = {
  logger?: ConsoleLike
  snackbar: SnackbarMessageInfo
  onSnackbarClose?: () => any
} & Testable

function AppSnackbar(props: AppSnackbarProps) {
  const {
    logger = console,
    snackbar,
    onSnackbarClose = () => null
  } = props
  const handleSnackbarClose = useCallback((_: React.SyntheticEvent<any, Event> | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    onSnackbarClose()
  }, [onSnackbarClose])

  useEffect(() => {
    logger.info('Updating Snackbar', snackbar)
  }, [logger, snackbar])

  return (
    <Snackbar
      data-cy={props['data-cy']}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      autoHideDuration={['success', 'info'].includes(snackbar.severity) ? 5000 : undefined}
      onClose={handleSnackbarClose}
      open={snackbar.open && snackbar.messageLines.length > 0}
    >
      <Alert
        data-cy={'snackbar-alert'}
        onClose={handleSnackbarClose}
        severity={snackbar.severity}
      >
        {snackbar.messageLines.map((messageLine, i) => (
          <Typography key={i} style={messageLine.style}>
            {messageLine.message}
          </Typography>
        ))}
      </Alert>
    </Snackbar>
  )
}

export default AppSnackbar
